import React from 'react'
import Weather from './Weather'


const App = () => {
  return (
    <div>
      <Weather />
    </div>
  )
}

export default App